import {Routes, Route,BrowserRouter} from 'react-router-dom';
import { useAdminAuthContext } from './administrator/admin/useAdminAuthContext';
import { AdminLogin } from './administrator/admin/AdminLogin';
import { AdminDashboard } from './administrator/admin/AdminDashboard';
import { AdminManage } from './administrator/admin/AdminManage';
import { AdminCreate } from './administrator/admin/AdminCreate';
import AdminManageProducts from './administrator/product/AdminManageProducts';
import AdminProductEditor from './administrator/product/AdminProductEditor';
import AdminEvaluations from "./administrator/evals/AdminEvaluations";

function App() {

  const {admin} = useAdminAuthContext();

  return (
    <BrowserRouter>
          <Routes>
            
                {/* Admin related routes */}
                <Route path='/administrator/login' element={<AdminLogin />} />
                <Route path='/administrator/dashboard' element=
                {
                  admin ?
                        <AdminDashboard />
                        :
                        <AdminLogin />
                } />
                <Route path='/administrator/admin/manage' element=
                {
                  admin ?
                        <AdminManage />
                        :
                        <AdminLogin />
                } />
                <Route path='/administrator/admin/create' element=
                {
                  admin ?
                        <AdminCreate />
                        :
                        <AdminLogin />
                } />

                <Route path='/administrator/products/manage' element=
                {
                  admin ?
                        <AdminManageProducts />
                        :
                        <AdminLogin />
                } />

              <Route
                  path="/administrator/product/create"
                  element={<AdminProductEditor />}
              />

              <Route
                  path="/administrator/product/edit/:id"
                  element={<AdminProductEditor />}
              />

              <Route
                path="/administrator/evaluations"
                element={
                  admin
                    ? <AdminEvaluations />
                    : <AdminLogin />
                }
              />
              


          </Routes>
    </BrowserRouter>
  );
}

export default App;
